import { Image } from "./image";
import { apiBaseAssets } from "../config/api";
import { useHistory } from "react-router";
import lc from "../utils/language";
export const News = ({ data, isRtl }) => {
  const history = useHistory();
  return (
    <div id="news" style={{ paddingTop: '70px', background: '#081526' }}>
      <div className="text-center" style={{ backgroundColor: "transparent" }}>
        <div className="container" style={{ backgroundColor: "transparent" }}>
          <div className="section-title" style={{ background: "none" }}>
            <h2 style={{ fontFamily: isRtl ? "amiriBold" : "Merriweather" }}>
              {data[lc("title", isRtl)]}
            </h2>
            <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: '#7FB6FF' }}>
              {data[lc("subTitle", isRtl)]}
            </p>
          </div>
          <div className="row">
            <div className="portfolio-items" style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", }}>
              {data.news.length > 0
                ? data.news.map((d, i) => (
                  <div
                    key={d._id}
                    className="col-sm-6 col-md-4 col-lg-4"
                    style={{ cursor: "pointer" }}
                    onClick={() => history.push("/news/" + d._id)}
                  >
                    <Image
                      isRtl={isRtl}
                      title={d[lc("title", isRtl)]}
                      largeImage={apiBaseAssets + d.background}
                      smallImage={apiBaseAssets + d.background}
                    />
                  </div>
                ))
                : isRtl
                  ? "ترقبوا اخر اخبارنا قريبا"
                  : "Wait to see our latest news soon.."}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
